import { render, staticRenderFns } from "./MPIcons.vue?vue&type=template&id=0503f2a0&"
import script from "./MPIcons.vue?vue&type=script&lang=js&"
export * from "./MPIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports